import Vue from 'vue'
import Router from 'vue-router'
import Waimai from '@/view/waimai'
import Taoword from '@/view/taoword'
import Dwz from '@/view/dwz'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Waimai',
      component: Waimai
    },
    {
      path: '/waimai',
      name: 'Waimai',
      component: Waimai
    },
    {
      path:'/taoword',
      name: 'Taoword',
      component: Taoword
    },{
      path:'/dwz',
      name: 'Dwz',
      component: Dwz
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js